<script setup lang="ts">
import { defineProps, ref } from 'vue';
import AddIcon from '@/dashboard/vue/components/icons/AddIcon.vue';
import { PaymentDiscountStatus } from '@/dashboard/store/purchaseStore';
import AddIconFilled from '@/dashboard/vue/components/icons/AddIconFilled.vue';
import CloseCircleFilledIcon from '@/dashboard/vue/components/icons/CloseCircleFilledIcon.vue';
import OkayIcon from '@/dashboard/vue/components/icons/OkayIcon.vue';

const props = defineProps<{
  code: string;
  status: PaymentDiscountStatus;
  onChange?: (value: string) => void;
  onAddClick?: () => void;
}>();

const codeModel = ref(props.code);

function change(event: Event) {
  props?.onChange?.(codeModel.value);
}

function click() {
  props.onAddClick?.();
}
</script>

<template>
  <div class="relative flex items-center">
    <div
      class="tppr-text-field w-[282px]"
      :class="{
        error: status === PaymentDiscountStatus.error,
        success: status === PaymentDiscountStatus.success,
      }"
    >
      <div class="tppr-text-field__field-container">
        <input
          v-model="codeModel"
          :disabled="status === PaymentDiscountStatus.success"
          type="text"
          class="!h-[40px]"
          placeholder="Enter a code here"
          @input="change"
        />
      </div>
    </div>

    <div class="absolute right-xs !w-auto">
      <div class="flex justify-end gap-xs">
        <button :disabled="code.length <= 0 || status === PaymentDiscountStatus.success" @click="click">
          <AddIcon v-if="status === PaymentDiscountStatus.default && code.length <= 0" class="stroke-gray-400 dark:stroke-gray-700" />
          <AddIconFilled v-if="status === PaymentDiscountStatus.default && code.length > 0" class="fill-brand-night-blue" />
          <CloseCircleFilledIcon v-if="status === PaymentDiscountStatus.error" class="fill-mid-red" />
          <OkayIcon v-if="status === PaymentDiscountStatus.success" width="24" height="24" class="fill-green" />
        </button>
      </div>
    </div>
  </div>
</template>
